<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import { YearService } from '../services/YearService';
import { NamedServices } from '../enum/NamedServices';
import {
  CaseListService,
  TranslationService,
  NamedBindings,
  getContainer,
  Contexts,
} from '@dandelion/core';

const container = getContainer(Contexts.DEFAULT);
const yearService = container.get(NamedServices.YearService) as YearService;
const caseListService = container.get(
  NamedBindings.CaseListService
) as CaseListService;
const ts = container.get(
  NamedBindings.TranslationService
) as TranslationService;
const currentYear = new Date().getFullYear();
const lastYear = currentYear - 1;
const selectedYear = ref(yearService.getSelectedYear());

const years = computed(() => {
  const yearList = [];
  for (let year = currentYear; year >= currentYear - 14; year--) {
    yearList.push(year);
  }
  return yearList;
});

watch(selectedYear, async () => {
  yearService.setSelectedYear(selectedYear.value);
  yearService.setAdmissionYear(selectedYear.value);
  await caseListService.updateCaseList();
});

const isCurrentYearSelected = computed(
  () => selectedYear.value === currentYear
);
</script>

<template>
  <div>
    <label
      id="select-year-label"
      for="year-select"
      v-html="`${ts.t('Select Year')}:`"
    ></label>
    <select id="year-select" v-model="selectedYear">
      <option
        v-for="year in years"
        :key="year"
        :value="year"
        v-html="year"
      ></option>
    </select>
    <!-- Displaying selected years -->
    <div v-if="isCurrentYearSelected">
      <span
        v-html="`${ts.t('Selected Years')}: ${currentYear} and ${lastYear}`"
      ></span>
    </div>
    <div v-else>
      <span v-html="`${ts.t('Selected Year')}: ${selectedYear}`"></span>
    </div>
  </div>
</template>
